import LoginPage from "./Login/LoginPage";

export default function SignedOutPage() {
  return <LoginPage signedOut />;
}
